var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStrikethrough48Line = function SvgIconStrikethrough48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 22.3H10v3.4h28v-3.4ZM25.8 27.7h-3.6v9.2h3.6v-9.2ZM22.2 20.3h3.6v-5.6H35v-3.6H13v3.6h9.2v5.6Z",
    fill: "current"
  })));
};
export default SvgIconStrikethrough48Line;